import React from 'react';
import './Select.scss';

const Select = ({ label, name, value, onChange, options = [], placeholder = '', required = false, error = '', className = '' }) => {
    return (
        <div className={`select-group ${className}`}>
            {label && <label htmlFor={name}>{label}{required && <span className="required">*</span>}</label>}
            <div className="select-wrapper">
                <select id={name} name={name} value={value} onChange={onChange} required={required} className={error ? 'error' : ''}>
                    {placeholder && <option value="">{placeholder}</option>}
                    {options.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                </select>
            </div>
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

export default Select;
